import React from 'react';

const CheckIcon = ({ width = 14, height = 10 }) => (
    <svg className="icon icon-check" width={width} height={height} viewBox="0 0 14 10">
        <g fill="#FFF">
            <path
                d="M17.212 7.228c.288-.298.763-.305 1.06-.016.27.262.301.678.088.975l-.072.085-8.25 8.5c-.272.28-.707.301-1.003.067l-.085-.079-3.25-3.5c-.281-.303-.264-.778.04-1.06.276-.256.693-.265.978-.036l.082.076 2.712 2.92 7.7-7.932z"
                transform="translate(-95 -41) translate(90 34)"
            />
        </g>
    </svg>
);

export default CheckIcon;
